import useCartStore from "../utils/cartStore";
import { Link } from "react-router-dom";
import { useState } from "react";
import emailjs from "@emailjs/browser";

const Cart = () => {
  const { items, removeFromCart, clearCart, getTotalPrice } = useCartStore();

  const [showForm, setShowForm] = useState(false);
  const [clientName, setClientName] = useState("");
  const [clientPhone, setClientPhone] = useState("");

  const total = getTotalPrice();

  const handleOrder = () => {
    if (!clientName || !clientPhone) {
      alert("Veuillez remplir vos informations");
      return;
    }

    const orderDetails = items
      .map((item, index) => {
        const perso = item.description
          ? `Personnalisation : ${item.description}`
          : "Aucune personnalisation";

        return `
[ Article ${index + 1} ]
Produit       : ${item.name}
Quantité      : ${item.quantity}
Prix unitaire : ${item.price} €
Sous-total    : ${(Number(item.price) * item.quantity).toFixed(2)} €
${perso}
────────────────────────────`;
      })
      .join("\n");

    emailjs
      .send(
        "service_esfde0h",
        "template_98tjtmm",
        {
          client_name: clientName,
          client_phone: clientPhone,
          order_details: orderDetails,
          total: total.toFixed(2),
        },
        "ENl3SMxqF8Dvo9m6N"
      )
      .then(() => {
        alert("Commande envoyée avec succès ! 🎉");
        clearCart();
        setShowForm(false);
        setClientName("");
        setClientPhone("");
      })
      .catch((error) => {
        console.error(error);
        alert("Erreur lors de l'envoi ❌");
      });
  };

  if (items.length === 0) {
    return (
      <div className="section-padding text-center">
        <p className="text-gray-500 mb-6">Votre panier est vide 🛒</p>
        <Link to="/" className="btn-primary">
          Continuer les achats
        </Link>
      </div>
    );
  }

  return (
    <div className="section-padding max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold mb-10">Panier</h1>

      <div className="space-y-6">
        {items.map((item) => {
          const key = item.cartItemId || item.id;
          return (
            <div
              key={key}
              className="flex items-center justify-between bg-white shadow rounded-2xl p-4"
            >
              <div className="flex items-center gap-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-20 h-20 object-cover rounded-xl"
                />
                <div>
                  <h2 className="font-semibold">{item.name}</h2>
                  <p className="text-sm text-gray-500">
                    {item.price} € × {item.quantity}
                  </p>
                  {item.description && (
                    <p className="text-xs text-gray-400 mt-1">
                      {item.description}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex items-center gap-4">
                <p className="font-bold">
                  {(Number(item.price) * item.quantity).toFixed(2)} €
                </p>
                <button
                  onClick={() => removeFromCart(key)}
                  className="text-red-500 hover:underline"
                >
                  Supprimer
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* TOTAL + ACTIONS */}
      <div className="mt-10 flex justify-between items-center">
        <button onClick={clearCart} className="text-gray-500 underline">
          Vider le panier
        </button>

        <div className="text-right">
          <p className="text-lg">Total :</p>
          <p className="text-2xl font-bold text-primary">
            {total.toFixed(2)} €
          </p>
          <button
            onClick={() => setShowForm(true)}
            className="btn-primary mt-4"
          >
            Confirmer la commande
          </button>
        </div>
      </div>

      {/* FORMULAIRE CLIENT */}
      {showForm && (
        <div className="mt-10 bg-white p-6 rounded-2xl shadow">
          <h2 className="text-xl font-bold mb-4">Informations client</h2>

          <input
            type="text"
            placeholder="Votre nom"
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
            className="w-full mb-4 px-4 py-3 border rounded-lg"
          />

          <input
            type="text"
            placeholder="Votre téléphone"
            value={clientPhone}
            onChange={(e) => setClientPhone(e.target.value)}
            className="w-full mb-4 px-4 py-3 border rounded-lg"
          />

          <button onClick={handleOrder} className="btn-primary w-full">
            Envoyer la commande
          </button>
        </div>
      )}
    </div>
  );
};

export default Cart;